// ConsoleSwitcher — the unified PW Manager's three consoles, one link each
// (2026-09-24). League / Coach / Official are one account now, so a person
// who scores games, coaches a team and runs a league moves between the
// consoles instead of needing three logins. Games (/official) and Teams
// (/coach) are open to every staff account; League only to an owner.
// Deliberately minimal — the web keeps its three consoles; this only joins them.
import { NavLink } from "react-router-dom";
import { useRole } from "./RoleContext";

export default function ConsoleSwitcher({ variant = "sidebar" }) {
  const { role } = useRole();
  if (!role) return null;
  const links = [
    { to: "/official", label: "Games" },
    { to: "/coach", label: "Teams" },
    ...(role.ownsLeague || role.accountType === "league" ? [{ to: "/league", label: "League" }] : []),
  ];

  if (variant === "bar") {
    return (
      <nav style={{ display: "flex", gap: 6 }} aria-label="Switch console">
        {links.map(({ to, label }) => (
          <NavLink key={to} to={to} style={({ isActive }) => ({
            padding: "6px 12px", borderRadius: 999, fontSize: 13, fontWeight: 600,
            textDecoration: "none", color: isActive ? "#0b1f12" : "#eaeae8",
            background: isActive ? "#33cc66" : "#2c2c29",
          })}>{label}</NavLink>
        ))}
      </nav>
    );
  }

  return (
    <div className="client-sidebar-nav" aria-label="Switch console" style={{ marginTop: 18 }}>
      <div className="client-sidebar-user-sub" style={{ padding: "0 12px 6px", textTransform: "uppercase", letterSpacing: 1 }}>
        PW Manager
      </div>
      {links.map(({ to, label }) => (
        <NavLink key={to} to={to}
          className={({ isActive }) => `client-sidebar-link${isActive ? " active" : ""}`}>
          <span>{label}</span>
        </NavLink>
      ))}
    </div>
  );
}
